import { PropertyCard } from 'components/Property'
import { usePropertiesQuery } from 'hooks/usePropertiesQuery'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { SearchPropertyModal } from 'components/SearchPropertyModal'

const Wrapper = styled.div`
  padding-bottom: 120px;

  ${up('sm')} {
    padding-bottom: 78px;
  }
`

const Intro = styled.div`
  padding: 30px 0 30px 0;

  ${up('sm')} {
    padding: 64px 0 64px 0;
  }
`

const Title = styled.h1`
  font-size: 26px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;

  ${up('sm')} {
    font-size: 26px;
    line-height: 30px;
  }
`

export const SearchProperty: ComponentType = () => (
  <Wrapper>
    <Container>
      <Intro>
        <Title>Encuentra tu propiedad</Title>
      </Intro>
      <SearchPropertyModal></SearchPropertyModal>
    </Container>
  </Wrapper>
)